import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PYCurves from './Pages/PYCurves/PYCurves';

import {Route, Routes, BrowserRouter} from "react-router";
//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

     <BrowserRouter>
     <Routes>
      <Route path="/" element={<PYCurves/>}/>
      
    </Routes>
    </BrowserRouter>
    
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
